import React, { Component } from "react";

class MemberDemographicsSVG extends React.Component {
  render() {
    return (
      <svg
        width="38"
        height="40"
        viewBox="0 0 38 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.2091 26.3954C25.0016 26.3954 29.6974 21.6996 29.6974 15.9071C29.6974 10.1145 25.0016 5.4187 19.2091 5.4187C13.4165 5.4187 8.7207 10.1145 8.7207 15.9071C8.7207 21.6996 13.4165 26.3954 19.2091 26.3954ZM19.2091 27.3954C25.5539 27.3954 30.6974 22.2519 30.6974 15.9071C30.6974 9.56222 25.5539 4.4187 19.2091 4.4187C12.8642 4.4187 7.7207 9.56222 7.7207 15.9071C7.7207 22.2519 12.8642 27.3954 19.2091 27.3954ZM18.2974 16.6048C17.9879 15.3293 18.7693 12.682 19.3001 11.8359L20.8958 9.51371C21.5417 8.484 22.9001 8.17289 23.9298 8.81883C24.9595 9.46477 25.2706 10.8232 24.6247 11.8529L23.3744 13.5667C22.8141 14.4599 20.4584 17.03 19.1716 17.2742L15.4167 22.526C15.24 22.7732 14.8963 22.8304 14.6491 22.6536C14.4019 22.4769 14.3448 22.1332 14.5215 21.886L18.2974 16.6048Z"
          fill="#3762B4"
        />
        <mask id="path-2-inside-1_235_52" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.209 31.814C27.9942 31.814 35.116 24.6922 35.116 15.907C35.116 7.1218 27.9942 0 19.209 0C10.4238 0 3.302 7.1218 3.302 15.907C3.302 24.6922 10.4238 31.814 19.209 31.814ZM19.2091 27.3953C25.5539 27.3953 30.6974 22.2518 30.6974 15.907C30.6974 9.56212 25.5539 4.4186 19.2091 4.4186C12.8642 4.4186 7.72069 9.56212 7.72069 15.907C7.72069 22.2518 12.8642 27.3953 19.2091 27.3953Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.209 31.814C27.9942 31.814 35.116 24.6922 35.116 15.907C35.116 7.1218 27.9942 0 19.209 0C10.4238 0 3.302 7.1218 3.302 15.907C3.302 24.6922 10.4238 31.814 19.209 31.814ZM19.2091 27.3953C25.5539 27.3953 30.6974 22.2518 30.6974 15.907C30.6974 9.56212 25.5539 4.4186 19.2091 4.4186C12.8642 4.4186 7.72069 9.56212 7.72069 15.907C7.72069 22.2518 12.8642 27.3953 19.2091 27.3953Z"
          fill="#3762B4"
        />
        <path
          d="M34.116 15.907C34.116 24.1399 27.4419 30.814 19.209 30.814V32.814C28.5464 32.814 36.116 25.2444 36.116 15.907H34.116ZM19.209 1C27.4419 1 34.116 7.67408 34.116 15.907H36.116C36.116 6.56951 28.5464 -1 19.209 -1V1ZM4.302 15.907C4.302 7.67408 10.9761 1 19.209 1V-1C9.87151 -1 2.302 6.56951 2.302 15.907H4.302ZM19.209 30.814C10.9761 30.814 4.302 24.1399 4.302 15.907H2.302C2.302 25.2444 9.87151 32.814 19.209 32.814V30.814ZM29.6974 15.907C29.6974 21.6995 25.0016 26.3953 19.2091 26.3953V28.3953C26.1062 28.3953 31.6974 22.8041 31.6974 15.907H29.6974ZM19.2091 5.4186C25.0016 5.4186 29.6974 10.1144 29.6974 15.907H31.6974C31.6974 9.00984 26.1062 3.4186 19.2091 3.4186V5.4186ZM8.72069 15.907C8.72069 10.1144 13.4165 5.4186 19.2091 5.4186V3.4186C12.3119 3.4186 6.72069 9.00984 6.72069 15.907H8.72069ZM19.2091 26.3953C13.4165 26.3953 8.72069 21.6995 8.72069 15.907H6.72069C6.72069 22.8041 12.3119 28.3953 19.2091 28.3953V26.3953Z"
          fill="#3762B4"
          mask="url(#path-2-inside-1_235_52)"
        />
        <path
          d="M1.57004 34.2655L8.20714 25.2097C10.1906 27.3287 11.6253 27.8319 14.9344 29.1613L11.5571 38.0479L8.64983 32.7403L1.57004 34.2655Z"
          fill="#3762B4"
          stroke="#3762B4"
        />
        <path
          d="M35.8942 33.6548L28.8228 24.934C26.9452 27.1473 25.5368 27.72 22.2966 29.2094L26.1038 37.9205L28.7484 32.4773L35.8942 33.6548Z"
          fill="#3762B4"
          stroke="#3762B4"
        />
        <circle cx="19.209" cy="15.907" r="15.407" stroke="#F5F5F5" />
      </svg>
    );
  }
}

export default MemberDemographicsSVG;



// WEBPACK FOOTER //
// ./src/svg/GoldenPaddleSVG.jsx